<app-breadcrumb [title]="'Nuevo'" [items]="['Vehiculos']" [active_item]="'Nuevo'"></app-breadcrumb>
<div class="container-fluid">
  <div class="col-sm-12 col-xl-12">
    <ngb-accordion [closeOthers]="true" [activeIds]="activePanel" #accordion="ngbAccordion">
      <ngb-panel id="static-1">
        <ng-template ngbPanelTitle>
          <i class="fa fa-car"></i>
          <span (click)="togglePanel('static-1')" class="ms-2"><strong>DATOS BÁSICOS DEL VEHÍCULO</strong></span>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="card">
            <div class="card-body">
              <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
                <span class="me-2"><strong>Modo de creación:</strong></span>
                <button type="button" (click)="seleccionarModoCreacion('manual')" [ngClass]="
                  modoCreacion === 'manual' ? 'btn btn-primary btn-sm' : 'btn btn-outline-primary btn-sm'
                ">
                  Crear manual
                </button>
                <button type="button" (click)="seleccionarModoCreacion('runt', runtModal)" [ngClass]="
                  modoCreacion === 'runt' ? 'btn btn-primary btn-sm' : 'btn btn-outline-primary btn-sm'
                ">
                  Datos RUNT
                </button>
                <span class="badge badge-light-info ms-1">
                  {{ modoCreacion === 'manual' ? 'Manual' : 'Datos RUNT' }}
                </span>
              </div>
              <form [formGroup]="formNuevo">
                <div class="row g-3 mb-3">
                  <div class="col-md-3">
                    <label class="form-label" for="servicio"><strong>Tipo de Servicio *:</strong></label>
                    <select #inputServicio id="servicio" class="form-control" formControlName="servicio" required
                      [ngClass]="{
                    'is-invalid':
                      formNuevo.controls['servicio'].invalid &&
                      formNuevo.controls['servicio'].touched
                  }" (change)="ValidarDocumentos($event)">
                      <option value="" disabled [selected]="!formNuevo.get('servicio')?.value">
                        Selecciona una opción
                      </option>
                      <option *ngFor="let opcion of tiposervicio" [value]="opcion.idServicio">
                        {{ opcion.Descripcion }}
                      </option>
                    </select>
                    <div *ngIf="
                    formNuevo.controls['servicio'].invalid &&
                    formNuevo.controls['servicio'].touched
                  " class="invalid-feedback">
                      {{ errores.servicio }}
                    </div>
                  </div>

                  <div class="col-md-3">
                    <label class="form-label" for="placa"><strong>Placa *:</strong></label>
                    <input #inputPlaca class="form-control" id="placa" type="text" placeholder="Ingrese la placa"
                      required (input)="formNuevo.controls['placa'].setValue($event.target.value.toUpperCase())"
                      formControlName="placa" maxlength="6" autocomplete="off" [ngClass]="{
                    'is-invalid':
                      formNuevo.controls['placa'].invalid &&
                      formNuevo.controls['placa'].touched
                  }" />

                    <div *ngIf="
                    formNuevo.controls['placa'].invalid &&
                    formNuevo.controls['placa'].touched
                  " class="invalid-feedback">
                      <span *ngIf="formNuevo.controls['placa'].errors?.required">La placa es obligatoria.</span>
                      <span *ngIf="formNuevo.controls['placa'].errors?.pattern">Debe contener exactamente 6 caracteres
                        alfanuméricos.</span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="interno"><strong>Número Interno *:</strong></label>
                    <input #inputInterno class="form-control" id="interno" type="text"
                      placeholder="Ingrese un número interno" required="" formControlName="interno" min="0"
                      autocomplete="off" [ngClass]="{
                    'is-invalid':
                      formNuevo.controls['interno'].invalid &&
                      formNuevo.controls['interno'].touched
                  }" />
                    <div *ngIf="
                    formNuevo.controls['interno'].invalid &&
                    formNuevo.controls['interno'].touched
                  " class="invalid-feedback">
                      {{ errores.interno }}
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="afiliacion"><strong>Fecha de Ingreso *:</strong></label>
                    <div class="input-group input-group-sm">
                      <input #inputAfiliacion id="afiliacion" type="date" class="form-control form-control-lg fs-14"
                        name="afiliacion" placeholder="dd/mm/aaaa" formControlName="afiliacion" [max]="maxDate"
                        autocomplete="off" (input)="onFechaAfiliacionChange($event)"
                        (blur)="formNuevo.get('afiliacion')?.markAsTouched()"
                        (change)="formNuevo.get('afiliacion')?.updateValueAndValidity()" [ngClass]="{
                        'is-invalid': formNuevo.controls['afiliacion'].invalid && 
                                     formNuevo.controls['afiliacion'].touched
                      }" />
                    </div>
                    <div *ngIf="(formNuevo.controls['afiliacion'].invalid && 
                              formNuevo.controls['afiliacion'].touched) ||
                             (formNuevo.controls['afiliacion'].value && 
                              formNuevo.controls['afiliacion'].invalid)" class="invalid-feedback d-block">
                      <span *ngIf="formNuevo.controls['afiliacion'].errors?.required">
                        La fecha de afiliación es obligatoria.
                      </span>
                      <span *ngIf="formNuevo.controls['afiliacion'].errors?.fechaFutura">
                        La fecha no puede ser futura.
                      </span>
                      <span *ngIf="formNuevo.controls['afiliacion'].errors?.fechaMuyAntigua">
                        La fecha es muy antigua (mínimo: 01/01/1990).
                      </span>
                    </div>
                  </div>

  <div class="col-md-3">
                    <label class="form-label" for="clase"><strong>Clase *:</strong></label>
                    <div class="input-group">
                      <div class="form-control p-0 border-0">
                        <ng-select #inputClase id="clase" [items]="tipos" bindLabel="tipos" bindValue="idTipos"
                          placeholder="Selecciona una opción" formControlName="clase"
                          class="js-example-placeholder-multiple" style="flex-grow: 1" [class.is-invalid]="
                      formNuevo.get('clase')?.invalid &&
                      formNuevo.get('clase')?.touched
                    ">
                        </ng-select>
                      </div>

                      <button type="button" class="btn btn-primary btn-sm" (click)="openModalClase(myModal2)">
                        <i class="icofont icofont-plus"></i>
                      </button>
                      <div *ngIf="
                      formNuevo.get('clase')?.invalid &&
                      formNuevo.get('clase')?.touched
                    " class="invalid-feedback">
                        {{ errores.clase }}
                      </div>

                    </div>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="marca"><strong>Marca *:</strong></label>
                    <div class="input-group">
                      <ng-select #inputMarca id="marca" [items]="marcas" bindLabel="marca" bindValue="id"
                        formControlName="marca" placeholder="Selecciona una opción" style="flex-grow: 1"
                        [class.is-invalid]="
                      formNuevo.get('marca')?.invalid &&
                      formNuevo.get('marca')?.touched
                    ">
                      </ng-select>
                    </div>

                    <div *ngIf="
                    formNuevo.get('marca')?.invalid &&
                    formNuevo.get('marca')?.touched
                  " class="invalid-feedback">
                      {{ errores.marca }}
                    </div>
                  </div>

                  <div class="col-md-3">
                    <label class="form-label" for="modelo"><strong>Modelo *:</strong></label>
                    <div class="input-group">
                      <ng-select #inputModelo id="modelo" [items]="modelos" bindLabel="modelo" bindValue="modelo"
                        placeholder="Selecciona una opción" class="js-example-placeholder-multiple" style="flex-grow: 1"
                        formControlName="modelo" [class.is-invalid]="
                      formNuevo.get('modelo')?.invalid &&
                      formNuevo.get('modelo')?.touched
                    ">
                      </ng-select>
                      <div *ngIf="
                      formNuevo.get('modelo')?.invalid &&
                      formNuevo.get('modelo')?.touched
                    " class="invalid-feedback">
                        {{ errores.modelo }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="relacion"><strong>Relación *:</strong></label>
                    <div class="input-group">
                      <ng-select #inputRelacion [items]="relaciones" bindLabel="relacion" bindValue="id"
                        placeholder="Selecciona una opción" formControlName="relacion"
                        (change)="onRelacionChange($event)" [class.is-invalid]="
                      formNuevo.get('relacion')?.invalid &&
                      formNuevo.get('relacion')?.touched
                    " class="js-example-placeholder-multiple" style="flex-grow: 1"></ng-select>
                    </div>

                    <div *ngIf="formNuevo.get('relacion')?.invalid && formNuevo.get('relacion')?.touched"
                      class="invalid-feedback">
                      {{ errores.relacion }}
                    </div>
                  </div>

                  <div class="col-md-6">
                    <label class="form-label"><strong>Empresa *:</strong></label>
                    <div class="input-group">
                      <div class="form-control p-0 border-0">
                        <ng-select #inputEmpresa [items]="empresas" bindLabel="nombre" bindValue="nit"
                          placeholder="Selecciona una opción" class="js-example-placeholder-multiple"
                          style="flex-grow: 1" formControlName="nitEmpresa" [class.is-invalid]="
                      formNuevo.get('nitEmpresa')?.invalid &&
                      formNuevo.get('nitEmpresa')?.touched
                    ">
                        </ng-select>
                      </div>
                      <button type="button" class="btn btn-primary btn-sm" (click)="openModalEmpresa(myModal)">
                        <i class="icofont icofont-plus"></i>
                      </button>
                    </div>
                    <div *ngIf="
                    formNuevo.get('nitEmpresa')?.invalid &&
                    formNuevo.get('nitEmpresa')?.touched
                  " class="invalid-feedback">
                      {{ errores.nitEmpresa }}
                    </div>
                  </div>

                  <div class="col-md-6">
                    <label class="form-label" for="Idpropietario"><strong>Propietario:</strong></label>
                    <div class="input-group">
                      <ng-select id="Idpropietario" [items]="propietarios" bindValue="cedula" bindLabel="cedula"
                        [searchFn]="buscarPropietario" placeholder="Selecciona una opción"
                        formControlName="Idpropietario" (change)="onPropietarioChange($event)"
                        class="js-example-placeholder-multiple" style="flex-grow: 1">
                        <ng-template ng-option-tmp let-item="item">
                          {{ item.primernombre }} {{ item.segundonombre }} {{ item.papellidos }} {{ item.seapellidos |
                          uppercase }}
                          - {{ item.cedula }}
                        </ng-template>

                        <ng-template ng-label-tmp let-item="item">
                          {{ item.primernombre }} {{ item.segundonombre }} {{ item.papellidos }} {{ item.seapellidos |
                          uppercase }}
                          - {{ item.cedula }}
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>

                

                  <div class="col-md-3">
                    <label class="form-label" for="sucursal"><strong>Sucursal oficina:</strong></label>
                    <div class="input-group">
                      <ng-select id="sucursal" name="sucursal" [items]="municipios" bindLabel="MUNICIPIO"
                        bindValue="IDMUN" placeholder="Selecciona una opción" class="js-example-placeholder-multiple"
                        style="flex-grow: 1" formControlName="sucursal">
                      </ng-select>
                    </div>
                  </div>
                  <div class="col-md-3" *ngIf="mostrarFechaConvenio">
                    <label class="form-label" for="convenio"><strong>Vigencia Convenio *:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="convenio" type="date" class="form-control form-control-lg fs-14" [min]="minDate"
                        formControlName="convenio" />
                    </div>
                    <div *ngIf="formNuevo.get('convenio')?.invalid && formNuevo.get('convenio')?.touched"
                      class="invalid-feedback d-block">
                      La fecha de vigencia del convenio es obligatoria.
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="password"><strong>Contraseña *:</strong></label>
                    <div class="input-group">
                      <input #inputPassword [type]="showPassword ? 'text' : 'password'" class="form-control"
                        id="password" placeholder="Ingrese una contraseña" required name="password"
                        formControlName="password" autocomplete="off" [class.is-invalid]="
             formNuevo.get('password')?.invalid &&
             formNuevo.get('password')?.touched
           " />

                      <!-- Botón con ícono -->
                      <button type="button" class="btn btn-primary" (click)="showPassword = !showPassword">
                        <i [class]="showPassword ? 'icofont icofont-eye-alt' : 'icofont icofont-eye-blocked'"></i>
                      </button>

                      <div *ngIf="
          formNuevo.get('password')?.invalid &&
          formNuevo.get('password')?.touched
        " class="invalid-feedback">
                        {{ errores.password }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="kilometraje"><strong>Kilometraje Actual:</strong></label>
                    <input #inputKilometraje class="form-control" id="kilometraje" type="number"
                      placeholder="Ingrese KM actual" required="" formControlName="kilometraje" min="0"
                      autocomplete="off" [ngClass]="{
                    'is-invalid':
                      formNuevo.controls['kilometraje'].invalid &&
                      formNuevo.controls['kilometraje'].touched
                  }" />
                    <div *ngIf="
                    formNuevo.controls['kilometraje'].invalid &&
                    formNuevo.controls['kilometraje'].touched
                  " class="invalid-feedback">
                      {{ errores.kilometraje }}
                    </div>

                  </div>
                  
                </div>
              </form>
            </div>

          </div>
        </ng-template>
      </ngb-panel>


      <ngb-panel id="static-2" *ngIf="validarLT">
        <ng-template ngbPanelTitle>
          <i class="icofont icofont-id-card"></i>
          <span class="ms-2 text-uppercase"><strong>LICENCIA DE TRANSITO</strong></span>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="card">
            <div class="card-body">
              <form [formGroup]="formNuevo">
                <div class="row g-3 mb-3">
                  <div class="col-md-3">
                    <label class="form-label" for="matricula">
                      <strong>Número de matricula:</strong></label>
                    <input class="form-control" id="matricula" type="text" placeholder="Ingrese un número de matricula"
                      formControlName="matricula" maxlength="20" autocomplete="off" />
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="organismo">
                      <strong>Organismo de transito:</strong></label>
                    <input class="form-control" id="organismo" type="text"
                      placeholder="Ingrese el organismo de transito" formControlName="organismo" autocomplete="off" />
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="fechalict"><strong>Fecha de Expedición:</strong></label>
                    <div class="input-group input-group-sm">
                      <div class="input-group input-group-sm">
                        <input id="fechalict" type="date" class="form-control form-control-lg fs-14" name="fechalict"
                          [max]="maxDate" formControlName="fechalict" autocomplete="off"
                          (change)="onFechaLicenciaChange($event)" (input)="onFechaLicenciaChange($event)"
                          (blur)="formNuevo.get('fechalict')?.markAsTouched()" [ngClass]="{
                          'is-invalid': formNuevo.controls['fechalict'].invalid && 
                                       formNuevo.controls['fechalict'].touched
                        }" />
                      </div>
                    </div>
                    <div *ngIf="formNuevo.controls['fechalict'].invalid && 
                              formNuevo.controls['fechalict'].touched" class="invalid-feedback d-block">
                      <span *ngIf="formNuevo.controls['fechalict'].errors?.fechaLicenciaFutura">
                        La fecha no puede ser futura.
                      </span>

                    </div>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="linea"> <strong>Linea:</strong></label>
                    <input class="form-control" id="linea" type="text" placeholder="Ingrese la linea"
                      formControlName="linea" maxlength="20" autocomplete="off" />
                  </div>

                  <div class="col-md-3">
                    <label class="form-label" for="cilindraje"> <strong>Cilindraje:</strong></label>
                    <input class="form-control" id="cilindraje" type="number" placeholder="Ingrese el cilindaje"
                      formControlName="cilindraje" maxlength="20" autocomplete="off" />
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="motor"> <strong>Número Motor:</strong></label>
                    <input class="form-control" id="motor" type="text" placeholder="Ingrese el número del motor"
                      formControlName="motor" maxlength="20" autocomplete="off" />
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="titular"> <strong>Titular:</strong></label>
                    <input class="form-control" id="titular" type="text" placeholder="Ingrese un titular"
                      formControlName="titular" autocomplete="off" />
                  </div>

                  <div class="col-md-3">
                    <label class="form-label" for="capacidad"> <strong>Capacidad de Pasajeros:</strong></label>
                    <input class="form-control" id="capacidad" type="number" placeholder="Ingrese la capacidad"
                      formControlName="capacidad" autocomplete="off" />
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="color"> <strong>Color:</strong></label>
                    <input class="form-control" id="color" type="text" placeholder="Ingrese el color"
                      formControlName="color" autocomplete="off" />
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="serie"> <strong>Número Serie:</strong></label>
                    <input class="form-control" id="serie" type="text" placeholder="Ingrese el número de serie"
                      formControlName="serie" maxlength="20" autocomplete="off" />
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="chasis"> <strong>Número Chasís:</strong></label>
                    <input class="form-control" id="chasis" type="text" placeholder="Ingrese el número de chasís"
                      formControlName="chasis" maxlength="20" autocomplete="off" />
                  </div>

                    <div class="col-md-3">
                      <label class="form-label" for="carroceria"> <strong>Carrocería:</strong></label>
                      <input class="form-control" id="carroceria" type="text" placeholder="Ingrese la carroceria"
                        formControlName="carroceria" maxlength="20" autocomplete="off" />
                    </div>

                  <div class="col-md-3">
                    <label class="form-label" for="combustible"><strong>Tipo Combustible:</strong></label>
                    <ng-select [items]="combustibles" bindLabel="nombre" bindValue="id"
                      placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                      formControlName="combustible">
                    </ng-select>
                  </div>

                   <div class="col-md-3">
                    <label class="form-label" for="vin"><strong>VIN:</strong></label>
                    <input class="form-control" id="vin" type="text" placeholder="Ingrese el VIN" formControlName="vin"  autocomplete="off" />
                  </div>

                  <div class="col-md-3">
                    <label class="form-label" for="observaciones">
                      <strong>Observaciones:</strong></label>
                    <input class="form-control" id="observaciones" type="text" placeholder="Ingrese observaciones"
                      formControlName="observaciones" autocomplete="off" />
                  </div>
                </div>
              </form>
            </div>

          </div>
        </ng-template>
      </ngb-panel>

      <ngb-panel id="static-3" *ngIf="validarTO">
        <ng-template ngbPanelTitle>
          <i class="icon-id-badge"></i>
          <span class="ms-2 text-uppercase"><strong>Tarjeta de Operación *</strong></span>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="card">
            <div class="card-body">
              <form [formGroup]="formTarjeta">
                <div class="row g-3 mb-3">
                  <!-- Este div debe tener el *ngIf -->
                  <div class="col-md-4" *ngIf="mostrarTarjeta">
                    <label class="form-label" for="numero_tarjeta"><strong>Número de Tarjeta de Operación
                        *:</strong></label>
                    <input #inputNumeroTarjeta id="numero_tarjeta" class="form-control" required type="text"
                      pattern="^[0-9]{1,25}$" maxlength="25" formControlName="numero_tarjeta"
                      placeholder="Ingrese el número" [ngClass]="{
                    'is-invalid':
                      formTarjeta.get('numero_tarjeta')?.invalid &&
                      formTarjeta.get('numero_tarjeta')?.touched
                  }" />
                    <div *ngIf="
                    formTarjeta.get('numero_tarjeta')?.invalid &&
                    formTarjeta.get('numero_tarjeta')?.touched
                  " class="invalid-feedback">
                      {{ errores.numero_tarjeta }}
                    </div>
                  </div>

                  <div class="col-md-4">
                    <label class="form-label" for="fecha_expedicion"><strong>Expedición *:</strong></label>
                    <div class="input-group input-group-sm">
                      <input #inputFechaExpedicionTarjeta id="fecha_expedicion" type="date"
                        class="form-control form-control-lg fs-14" name="fecha_expedicion" placeholder="Last name"
                        [max]="maxDate" formControlName="fecha_expedicion" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for="fecha_vencimiento"><strong>Vencimiento *:</strong></label>
                    <div class="input-group input-group-sm">
                      <input #inputFechaVencimientoTarjeta id="fecha_vencimiento" type="date"
                        class="form-control form-control-lg fs-14" name="fecha_vencimiento" placeholder="Last name"
                        [min]="minDate" formControlName="fecha_vencimiento" />
                    </div>
                  </div>
                </div>
              </form>
            </div>

          </div>
        </ng-template>
      </ngb-panel>

      <ngb-panel id="static-4" *ngIf="validarSOAT">
        <ng-template ngbPanelTitle>
          <i class="icofont icofont-safety"></i>
          <span class="ms-2 text-uppercase"><strong>Seguro Obligatario (SOAT) *</strong></span>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="card">
            <div class="card-body">
              <form [formGroup]="formSoat">
                <div class="row g-3 mb-3">
                  <div class="col-md-6">
                    <label class="form-label" for="aseguradora"><strong>Aseguradora SOAT *:</strong></label>
                    <div class="input-group">
                      <div class="form-control p-0 border-0">
                        <ng-select #inputAseguradoraSoat [items]="empresasaseguradora" bindLabel="nombre"
                          bindValue="nit" placeholder="Selecciona una opción" class="js-example-placeholder-multiple"
                          style="flex-grow: 1" formControlName="aseguradora" [class.is-invalid]="
                      formSoat.get('aseguradora')?.invalid &&
                      formSoat.get('aseguradora')?.touched">
                        </ng-select>
                        <div *ngIf="
                    formSoat.controls['aseguradora'].invalid &&
                    formSoat.controls['aseguradora'].touched
                  " class="invalid-feedback">
                          {{ errores.aseguradora }}
                        </div>
                      </div>
                      <button type="button" class="btn btn-primary btn-sm" (click)="openModalEmpresa(myModal)">
                        <i class="icofont icofont-plus"></i>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="id_soat"><strong>Número de SOAT *:</strong></label>
                    <input #inputIdSoat class="form-control" id="id_soat" type="text"
                      placeholder="Ingrese el número" formControlName="id_soat" pattern="^[0-9]{1,25}$"
                      maxlength="25" />
                    <div *ngIf="
                    formSoat.controls['id_soat'].invalid &&
                    formSoat.controls['id_soat'].touched
                  " class="invalid-feedback">
                      <span *ngIf="formSoat.controls['id_soat'].errors?.required">El número de soat es
                        obligatorio.</span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="fecha_soat"><strong>Fecha Expedición SOAT *:</strong></label>
                    <div class="input-group input-group-sm">
                      <input #inputFechaSoat id="fecha_soat" type="date" class="form-control form-control-lg fs-14"
                        name="fecha_soat" [max]="maxDate" formControlName="fecha_soat" />
                    </div>
                    <div class="valid-feedback">Looks good!</div>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="vencimiento_soat"><strong>Fecha Vencimiento de SOAT
                        *:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="vencimiento_soat" type="date" class="form-control form-control-lg fs-14"
                        name="vencimiento_soat" [min]="minDate" formControlName="vencimiento_soat" />
                    </div>
                  </div>

                  <div class="col-md-3">
                    <label class="form-label" for="valor"> <strong>Valor:</strong></label>
                    <input class="form-control" id="valor" type="number" placeholder="Ingrese el número"
                      formControlName="valor" />
                    <div class="valid-feedback">Looks good!</div>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="tarifa"><strong>Tarifa:</strong></label>
                    <input class="form-control" id="tarifa" type="number" placeholder="Ingrese el número"
                      formControlName="tarifa" />
                    <div class="valid-feedback">Looks good!</div>
                  </div>
                </div>
              </form>
            </div>

          </div>
        </ng-template>
      </ngb-panel>

      <ngb-panel id="static-5" *ngIf="validarCDA">
        <ng-template ngbPanelTitle>
          <i class="icofont icofont-tools-alt-2"></i>
          <span class="ms-2 text-uppercase"><strong>Revision Tecnicomecanica (RTM) *</strong></span>

        </ng-template>
        <ng-template ngbPanelContent>
          <div class="col-sm-12 col-xl-12">
            <ul ngbNav #nav="ngbNav" [(activeId)]="active" [destroyOnHide]="false" class="nav nav-tabs">
              <li [ngbNavItem]="1">
                <a ngbNavLink><strong>RTM</strong></a>
                <ng-template ngbNavContent>
                  <div class="card">
                    <div class="card-body">
                      <form [formGroup]="formCda">
                        <div class="row g-3 mb-3">
                          <div class="col-md-6">
                            <label class="form-label" for="centrocda"><strong>Centro RTM *:</strong></label>
                            <div class="input-group">
                              <div class="form-control p-0 border-0">
                                <ng-select #inputCentroCda [items]="empresascda " bindLabel="nombre" required
                                  bindValue="nit" placeholder="Selecciona una opción"
                                  class="js-example-placeholder-multiple" style="flex-grow: 1"
                                  formControlName="centrocda">
                                </ng-select>
                              </div>
                              <button type="button" class="btn btn-primary btn-sm" (click)="openModalEmpresa(myModal)">
                                <i class="icofont icofont-plus"></i>
                              </button>
                            </div>
                          </div>

                          <div class="col-md-3">
                            <label class="form-label" for="idcda">
                              <strong>Certificado *:</strong></label>
                            <input #inputCertificadoCda class="form-control" id="idcda" type="text" required
                              placeholder="Ingrese el certificado" formControlName="idcda" />
                          </div>

                          <div class="col-md-3">
                            <label class="form-label" for="fechacda">
                              <strong>Fecha de Expedición RTM*:</strong></label>
                            <div class="input-group input-group-sm">
                              <input #inputFechaExpedicionCda id="fechacda" type="date"
                                class="form-control form-control-lg fs-14" name="fechacda" [max]="maxDate" required
                                formControlName="fechacda" />
                            </div>
                          </div>
                          <div class="col-md-3">
                            <label class="form-label" for="vcda">
                              <strong>Fecha de Vencimiento RTM *:</strong></label>
                            <div class="input-group input-group-sm">
                              <input #inputFechaVencimientoCda id="vcda" type="date"
                                class="form-control form-control-lg fs-14" name="vcda" [min]="minDate"
                                formControlName="vcda" />
                            </div>
                          </div>
                        </div>

                        <br />
                      </form>
                    </div>

                  </div>
                </ng-template>
              </li>
              <li [ngbNavItem]="2">
                <a ngbNavLink><strong>EXTINTOR</strong></a>
                <ng-template ngbNavContent>
                  <div class="card">
                    <div class="card-body">
                      <form [formGroup]="formExtintor">
                        <div class="row g-3 mb-3">
                          <div class="col-md-4">
                            <label class="form-label" for="idextintor">
                              <strong>ID Extintor</strong> <span class="text-danger">*</span>
                            </label>
                            <input #inputIdExtintor class="form-control" id="idextintor" type="text"
                              placeholder="Ingrese el id del extintor" formControlName="idextintor" maxlength="20"
                              [ngClass]="{'is-invalid': formExtintor.get('idextintor')?.invalid && formExtintor.get('idextintor')?.touched}" />
                            <div *ngIf="formExtintor.get('idextintor')?.invalid && formExtintor.get('idextintor')?.touched" class="invalid-feedback">
                              El ID del extintor es obligatorio.
                            </div>
                          </div>
                          <div class="col-md-4">
                            <label class="form-label" for="frecarga">
                              <strong>Recarga de extintor</strong> <span class="text-danger">*</span>
                            </label>
                            <div class="input-group input-group-sm">
                              <input #inputFrecarga id="frecarga" type="date" class="form-control form-control-lg fs-14"
                                name="frecarga" [max]="maxDate" formControlName="frecarga"
                                [ngClass]="{'is-invalid': formExtintor.get('frecarga')?.invalid && formExtintor.get('frecarga')?.touched}" />
                            </div>
                            <div *ngIf="formExtintor.get('frecarga')?.invalid && formExtintor.get('frecarga')?.touched" class="invalid-feedback d-block">
                              La fecha de recarga es obligatoria.
                            </div>
                          </div>
                          <div class="col-md-4">
                            <label class="form-label" for="vrecarga">
                              <strong>Vencimiento</strong> <span class="text-danger">*</span>
                            </label>
                            <div class="input-group input-group-sm">
                              <input #inputVrecarga id="vrecarga" type="date" class="form-control form-control-lg fs-14"
                                name="vrecarga" [min]="minDate" formControlName="vrecarga"
                                [ngClass]="{'is-invalid': formExtintor.get('vrecarga')?.invalid && formExtintor.get('vrecarga')?.touched}" />
                            </div>
                            <div *ngIf="formExtintor.get('vrecarga')?.invalid && formExtintor.get('vrecarga')?.touched" class="invalid-feedback d-block">
                              La fecha de vencimiento es obligatoria.
                            </div>
                          </div>
                        </div>

                        <br />
                      </form>
                    </div>

                  </div>
                </ng-template>
              </li>
            </ul>
            <div [ngbNavOutlet]="nav" class="mt-2"></div>
          </div>
        </ng-template>
      </ngb-panel>

      <ngb-panel id="static-6" *ngIf="validarBIM">
        <ng-template ngbPanelTitle>
          <i class="icofont icofont-check-circled"></i>
          <span class="ms-2 text-uppercase"><strong>Revisión Bimestral *</strong></span>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="card">
            <div class="card-body">
              <form [formGroup]="formBimestral">
                <div class="row g-3 mb-3">
                  <div class="col-md-6">
                    <label class="form-label" for="centro_diagnostico"><strong>Centro RTM:</strong></label>
                    <div class="input-group">
                      <div class="form-control p-0 border-0">
                        <ng-select #inputCentroBim [items]="empresascda" bindLabel="nombre" bindValue="nit"
                          placeholder="Selecciona una opción" class="js-example-placeholder-multiple"
                          style="flex-grow: 1" formControlName="centro_diagnostico">
                        </ng-select>
                      </div>
                      <button type="button" class="btn btn-primary btn-sm" (click)="openModalEmpresa(myModal)">
                        <i class="icofont icofont-plus"></i>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="revision_aprobada"><strong>Revisión Aprobada</strong></label>
                    <ng-select #inputRevisionBim [items]="Revision" bindLabel="label" bindValue="value"
                      placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                      formControlName="revision_aprobada">
                    </ng-select>
                    <div class="valid-feedback">Looks good!</div>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="ultima_revision"><strong>Última Revisión *:</strong></label>
                    <div class="input-group input-group-sm">
                      <input #inputUltimaRevisionBim id="ultima_revision" type="date"
                        class="form-control form-control-lg fs-14" name="ultima_revision" [max]="maxDate"
                        formControlName="ultima_revision" />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="proxima_revision"><strong>Próxima Revisión *:</strong></label>
                    <div class="input-group input-group-sm">
                      <input #inputProximaRevisionBim id="proxima_revision" type="date"
                        class="form-control form-control-lg fs-14" name="proxima_revision" [min]="minDate"
                        formControlName="proxima_revision" />
                    </div>
                  </div>
                </div>
              </form>
            </div>

          </div>
        </ng-template>
      </ngb-panel>

      <ngb-panel id="static-7" *ngIf="validarRCC || validarRCE || validarPTR">
        <ng-template ngbPanelTitle>
          <i class="icofont icofont-building-alt"></i>
          <span class="ms-2 text-uppercase"><strong>Pólizas</strong></span>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="col-sm-12 col-xl-12">
            <ul ngbNav #nav="ngbNav" [(activeId)]="active2" class="nav-tabs">
              <li [ngbNavItem]="1" class="nav-tabs" *ngIf="validarRCC">
                <a ngbNavLink class="text-uppercase"><strong>Responsabilidad Contractual*</strong></a>
                <ng-template ngbNavContent>
                  <div class="card">
                    <div class="card-header">
                      <form [formGroup]="formContractual">
                        <div class="row g-3 mb-3">
                          <div class="col-md-3">
                            <label class="form-label" for="numero"><strong>Número de Póliza:</strong></label>
                            <input #inputNumeroCont class="form-control" id="numero" type="text" required
                              placeholder="Ingrese el número RCC" formControlName="numeroRCC" maxlength="30"
                              autocomplete="off" />
                          </div>
                          <div class="col-md-6">
                            <label class="form-label" for="aseguradora"><strong>Aseguradora *:</strong></label>
                            <div class="input-group">
                              <div class="form-control p-0 border-0">
                                <ng-select #inputAseguradoraCont [items]="empresasaseguradora" bindLabel="nombre"
                                  bindValue="nit" placeholder="Selecciona una opción"
                                  class="js-example-placeholder-multiple" style="flex-grow: 1" required
                                  formControlName="aseguradoraRCC">
                                </ng-select>
                              </div>
                              <button type="button" class="btn btn-primary btn-sm" (click)="openModalEmpresa(myModal)">
                                <i class="icofont icofont-plus"></i>
                              </button>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <label class="form-label" for="intermediaria">
                              <strong>Intermediaria :</strong></label>
                            <input #inputIntermediariaCont class="form-control" id="intermediaria" type="text"
                              placeholder="Ingrese el intermediario" required formControlName="intermediariaRCC"
                              maxlength="30" autocomplete="off" />
                          </div>
                          <div class="col-md-3">
                            <label class="form-label" for="fecha_expedicion">
                              <strong>Fecha de Expedición *:</strong></label>
                            <div class="input-group input-group-sm">
                              <input #inputFechaExpedicionCont id="fecha_expedicion" type="date"
                                class="form-control form-control-lg fs-14" name="fecha_expedicion" [max]="maxDate"
                                required formControlName="fecha_expedicionRCC" />
                            </div>
                          </div>
                          <div class="col-md-3">
                            <label class="form-label" for="fecha_vencimiento">
                              <strong>Fecha de Vencimiento *:</strong></label>
                            <div class="input-group input-group-sm">
                              <input #inputFechaVencimientoCont id="fecha_vencimiento" type="date"
                                class="form-control form-control-lg fs-14" name="fecha_vencimiento" [min]="minDate"
                                formControlName="fecha_vencimientoRCC" />
                            </div>
                          </div>

                        </div>

                        <br />
                      </form>
                    </div>
                  </div>
                </ng-template>
              </li>
              <li [ngbNavItem]="2" class="nav-tabs" *ngIf="validarRCE">
                <a ngbNavLink class="text-uppercase"><strong>Responsabilidad Civil Extracontractual *</strong></a>
                <ng-template ngbNavContent>
                  <div class="card">
                    <div class="card-header">
                      <form [formGroup]="formExtracontractual">
                        <div class="row g-3 mb-3">
                          <div class="col-md-3">
                            <label class="form-label" for="numero"><strong>Número de Póliza:</strong></label>
                            <input #inputNumeroExt class="form-control" id="numero" type="text" required
                              placeholder="Ingrese el número RCE" formControlName="numeroRCE" maxlength="30"
                              autocomplete="off" />
                          </div>
                          <div class="col-md-6">
                            <label class="form-label" for="aseguradoraRCE"><strong>Aseguradora *:</strong></label>
                            <div class="input-group">
                              <div class="form-control p-0 border-0">
                                <ng-select #inputAseguradoraExt [items]="empresasaseguradora" bindLabel="nombre"
                                  bindValue="nit" placeholder="Selecciona una opción" required
                                  class="js-example-placeholder-multiple" style="flex-grow: 1"
                                  formControlName="aseguradoraRCE">
                                </ng-select>
                              </div>
                              <button type="button" class="btn btn-primary btn-sm" (click)="openModalEmpresa(myModal)">
                                <i class="icofont icofont-plus"></i>
                              </button>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <label class="form-label" for="intermediariaRCE">
                              <strong>Intermediaria:</strong></label>
                            <input #inputIntermediariaExt class="form-control" id="intermediariaRCE" type="text"
                              placeholder="Ingrese el intermediario" required formControlName="intermediariaRCE"
                              maxlength="30" autocomplete="off" />
                          </div>
                          <div class="col-md-3">
                            <label class="form-label" for="fecha_expedicionRCE">
                              <strong>Fecha de Expedición *:</strong></label>
                            <div class="input-group input-group-sm">
                              <input #inputFechaExpedicionExt id="fecha_expedicionRCE" type="date"
                                class="form-control form-control-lg fs-14" name="fecha_expedicionRCE" [max]="maxDate"
                                formControlName="fecha_expedicionRCE" />
                            </div>
                          </div>
                          <div class="col-md-3">
                            <label class="form-label" for="fecha_vencimientoRCE">
                              <strong>Fecha de Vencimiento *:</strong></label>
                            <div class="input-group input-group-sm">
                              <input #inputFechaVencimientoExt id="fecha_vencimientoRCE" type="date"
                                class="form-control form-control-lg fs-14" name="fecha_vencimientoRCE" [min]="minDate"
                                required formControlName="fecha_vencimientoRCE" />
                            </div>
                          </div>

                        </div>

                        <br />
                      </form>
                    </div>
                  </div>
                </ng-template>
              </li>
              <li [ngbNavItem]="3" class="nav-tabs" *ngIf="validarPTR">
                <a ngbNavLink class="text-uppercase"><strong>TODO RIESGOS</strong></a>
                <ng-template ngbNavContent>
                  <div class="card">
                    <div class="card-header">
                      <form [formGroup]="formTodoriesgo">
                        <div class="row g-3 mb-3">
                          <div class="col-md-3">
                            <label class="form-label" for="numero"><strong>Número:</strong></label>
                            <input #inputNumeroTodo class="form-control" id="numeroTD" type="text" required
                              placeholder="Ingrese el número" formControlName="numeroTD" maxlength="30"
                              autocomplete="off" />
                          </div>
                          <div class="col-md-6">
                            <label class="form-label" for="aseguradora"><strong>Aseguradora:</strong></label>
                            <div class="input-group">
                              <div class="form-control p-0 border-0">
                                <ng-select #inputAseguradoraTodo [items]="empresasaseguradora" bindLabel="nombre"
                                  bindValue="nit" placeholder="Selecciona una opción" required
                                  class="js-example-placeholder-multiple" style="flex-grow: 1"
                                  formControlName="aseguradoraTD">
                                </ng-select>
                              </div>
                              <button type="button" class="btn btn-primary btn-sm" (click)="openModalEmpresa(myModal)">
                                <i class="icofont icofont-plus"></i>
                              </button>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <label class="form-label" for="fecha_expedicion">
                              <strong>Fecha de Expedición:</strong></label>
                            <div class="input-group input-group-sm">
                              <input #inputFechaExpedicionTodo id="fecha_expedicionTD" type="date"
                                class="form-control form-control-lg fs-14" name="fecha_expedicionTD" [max]="maxDate"
                                required formControlName="fecha_expedicionTD" />
                            </div>
                          </div>
                          <div class="col-md-3">
                            <label class="form-label" for="fecha_vencimientoTD">
                              <strong>Fecha de Vencimiento:</strong></label>
                            <div class="input-group input-group-sm">
                              <input #inputFechaVencimientoTodo id="fecha_vencimientoTD" type="date"
                                class="form-control form-control-lg fs-14" name="fecha_vencimientoTD" required
                                [min]="minDate" formControlName="fecha_vencimientoTD" />
                            </div>
                          </div>

                        </div>

                        <br />
                      </form>
                    </div>
                  </div>
                </ng-template>
              </li>
            </ul>
            <div [ngbNavOutlet]="nav" class="mt-2"></div>
          </div>
        </ng-template>
      </ngb-panel>


    </ngb-accordion>

    <div class="btn-showcase my-4">
      <button type="button" class="btn btn-primary" (click)="guardarVehiculo()" [disabled]="guardandoVehiculo">
        <span *ngIf="!guardandoVehiculo">GUARDAR</span>
        <span *ngIf="guardandoVehiculo">
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          Guardando...
        </span>
      </button>
    </div>
  </div>

  <ng-template #runtModal let-modal>
    <div class="card border-4 rounded-3">
      <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
        <h5 class="mb-0"><strong>CONSULTA DATOS RUNT</strong></h5>
      </div>
      <div class="modal-body">
        <form [formGroup]="formRunt">
          <div class="row g-3">
            <div class="col-md-12">
              <label class="form-label" for="documentType"><strong>Tipo de documento *</strong></label>
              <ng-select id="documentType" [items]="tiposDocumentoRunt" bindLabel="label" bindValue="value"
                placeholder="Seleccione tipo de documento" formControlName="documentType"
                [class.is-invalid]="formRunt.get('documentType')?.invalid && formRunt.get('documentType')?.touched">
              </ng-select>
            </div>
            <div class="col-md-6">
              <label class="form-label" for="documentNumber"><strong>Número de documento PROPIETARIO*</strong></label>
              <input id="documentNumber" class="form-control" type="text" formControlName="documentNumber"
                placeholder="Ingrese solo números" autocomplete="off"
                [class.is-invalid]="formRunt.get('documentNumber')?.invalid && formRunt.get('documentNumber')?.touched" />
              <div *ngIf="formRunt.get('documentNumber')?.invalid && formRunt.get('documentNumber')?.touched" class="invalid-feedback">
                Debe ingresar un valor numérico.
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label" for="plateRunt"><strong>Placa (SIN ESPACIOS - NI GUIONES) *</strong></label>
              <input id="plateRunt" class="form-control" type="text" formControlName="plate" maxlength="6"
                placeholder="Ingrese placa alfanumérica EJ: ABC123" autocomplete="off"
                (input)="formRunt.get('plate')?.setValue($event.target.value.toUpperCase(), { emitEvent: false })"
                [class.is-invalid]="formRunt.get('plate')?.invalid && formRunt.get('plate')?.touched" />
              <div *ngIf="formRunt.get('plate')?.invalid && formRunt.get('plate')?.touched" class="invalid-feedback">
                Debe ingresar solo caracteres alfanuméricos.
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" (click)="consultarDatosRunt(modal)">Consultar</button>
        <button class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
      </div>
    </div>
  </ng-template>

  <ng-template #myModal let-modal>
    <div class="card border-4 rounded-3">
      <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
        <h5 class="mb-0"><strong>CREACIÓN DE ENTIDADES / EMPRESAS</strong></h5>
      </div>
      <div class="modal-body">
        <form [formGroup]="formEmpresa">
          <!-- Inputs antes de la tabla -->
          <div class="row g-3">
            <div class="col-md-3">
              <label class="form-label" for="nit"><strong>CC / NIT *:</strong></label>
              <input #inputNit class="form-control" id="nit" type="number" required
                placeholder="Ingrese su número de documento o nit" formControlName="nit"
                [class.is-invalid]="formEmpresa.get('nit')?.invalid && validate"
                (input)="limitarLongitud($event, 10)" />
              <div *ngIf="formEmpresa.get('nit')?.invalid && validate" class="invalid-feedback">
                Por favor, ingresa un número de documento.
              </div>
            </div>

            <div class="col-md-3">
              <label class="form-label" for="digito"><strong>Dígito de Verificación *:</strong></label>
              <input class="form-control" id="digito" type="number" placeholder="Ingrese el dígito de verificación"
                required formControlName="digito" [class.is-invalid]="formEmpresa.get('digito')?.invalid && validate" />
              <div *ngIf="formEmpresa.get('digito')?.invalid && validate" class="invalid-feedback">
                Por favor, ingresa un digito de verificación.
              </div>
            </div>

            <div class="col-md-3">
              <label class="form-label" for="nombre"><strong>Nombre Completo/Razon Social *:</strong></label>
              <input #inputNombre class="form-control" id="nombre" type="text"
                placeholder="Ingrese el nombre o razon social" required formControlName="nombre" [class.is-invalid]="
                formEmpresa.get('nombre')?.invalid && validate
              " />
              <div *ngIf="formEmpresa.get('nombre')?.invalid && validate" class="invalid-feedback">
                Por favor, ingresa un nombre o razón social.
              </div>
            </div>
            <div class="col-md-3">
              <label class="form-label" for="direccion"> <strong>Dirección *:</strong></label>
              <input class="form-control" id="direccion" type="text" placeholder="Ingresa una dirección" required
                formControlName="direccion" [class.is-invalid]="formEmpresa.get('direccion')?.invalid && validate" />
              <div *ngIf="formEmpresa.get('direccion')?.invalid && validate" class="invalid-feedback">
                Por favor, ingresa una dirección.
              </div>
            </div>
            <div class="col-md-3">
              <label class="form-label" for="ciudad"> <strong>Ciudad *:</strong></label>
              <ng-select #inputCiudad id="ciudad" [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
                placeholder="Selecciona una ciudad" class="js-example-placeholder-multiple" name="lugarex" required
                formControlName="ciudad" [class.is-invalid]="formEmpresa.get('ciudad')?.invalid && validate">
              </ng-select>
              <div *ngIf="formEmpresa.get('ciudad')?.invalid && validate" class="invalid-feedback">
                Por favor, ingresa una ciudad.
              </div>
            </div>
            <div class="col-md-3">
              <label class="form-label" for="telefono"><strong>Teléfono fijo</strong></label>
              <input class="form-control" id="telefono" type="number" required placeholder="Ingresa el teléfono fijo"
                formControlName="telefono" (input)="limitarLongitud($event, 10)" />
            </div>
            <div class="col-md-3">
              <label class="form-label" for="celular"><strong>Teléfono celular *:</strong></label>
              <input class="form-control" id="celular" type="number" required placeholder="Ingresa el teléfono celular"
                formControlName="celular" (input)="limitarLongitud($event, 10)"
                [class.is-invalid]="formEmpresa.get('celular')?.invalid && validate" />
              <div *ngIf="formEmpresa.get('celular')?.invalid && validate" class="invalid-feedback">
                Por favor, ingresa un número de celular.
              </div>
            </div>
            <div class="col-md-3">
              <label class="form-label" for="email"> <strong>Correo electrónico:</strong></label>
              <input class="form-control" id="email" type="text" placeholder="Ingresa un correo valido"
                formControlName="email" required [class.is-invalid]="formEmpresa.get('email')?.invalid && validate" />
              <div *ngIf="formEmpresa.get('email')?.invalid && validate" class="invalid-feedback">
                Por favor, ingresa un correo electronico.
              </div>
            </div>
            <div class="row g-3 mb-3">
              <div class="mb-3">
                <label><strong>Observaciones:</strong></label>
                <textarea class="form-control" id="observaciones" rows="3" formControlName="observaciones"></textarea>
              </div>
            </div>
          </div>

          <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
            <h5 class="mb-0"><strong>TIPO DE EMPRESA / ENTIDAD</strong></h5>
          </div>
          <!-- Tabla con exámenes -->
          <div class="row">
            <div class="col-md-4 my-4">
              <label class="d-block" for="chk-ani1">
                <input class="checkbox_animated me-2" id="chk-ani1" type="checkbox" formControlName="eps" />
                <strong>EPS (SALUD)</strong>
              </label>
              <label class="d-block" for="chk-ani2">
                <input class="checkbox_animated me-2" id="chk-ani2" type="checkbox" formControlName="arl" />
                <strong>ARL (RIEGOS LABORALES)</strong>
              </label>
              <label class="d-block" for="chk-ani3">
                <input class="checkbox_animated me-2" id="chk-ani3" type="checkbox" formControlName="afp" />
                <strong>AFP (FONDO DE PENSIONES)</strong>
              </label>
              <label class="d-block" for="chk-ani4">
                <input class="checkbox_animated me-2" id="chk-ani4" type="checkbox" formControlName="ces" />
                <strong>CES (CESANTIAS)</strong>
              </label>
              <label class="d-block" for="chk-ani5">
                <input class="checkbox_animated me-2" id="chk-ani5" type="checkbox" formControlName="ccf" />
                <strong>CCF (CAJA DE COMPESANCIÓN FAMILIAR)</strong>
              </label>
              <label class="d-block" for="chk-ani6">
                <input class="checkbox_animated me-2" id="chk-ani6" type="checkbox" formControlName="bancos" />
                <strong>BANCOS</strong>
              </label>
            </div>
            <div class="col-md-4 my-4">
              <label class="d-block" for="chk-ani7">
                <input class="checkbox_animated me-2" id="chk-ani7" type="checkbox"
                  formControlName="transporte" /><strong>EMPRESA</strong> DE TRANSPORTES
              </label>
              <label class="d-block" for="chk-ani8">
                <input class="checkbox_animated me-2" id="chk-ani8" type="checkbox" formControlName="colegio" />
                <strong>COLEGIO</strong>
              </label>
              <label class="d-block" for="chk-ani9">
                <input class="checkbox_animated me-2" id="chk-ani9" type="checkbox" formControlName="cda" />
                <strong>CDA</strong>
              </label>
              <label class="d-block" for="chk-ani10">
                <input class="checkbox_animated me-2" id="chk-ani10" type="checkbox" formControlName="taller" />
                <strong>TALLER MECÁNICO</strong>
              </label>
              <label class="d-block" for="chk-ani11">
                <input class="checkbox_animated me-2" id="chk-ani11" type="checkbox" formControlName="eds" />
                <strong>EDS</strong>
              </label>
              <label class="d-block" for="chk-ani12">
                <input class="checkbox_animated me-2" id="chk-ani12" type="checkbox" formControlName="contratista" />
                <strong>CLIENTES/CONTRATANTES</strong>
              </label>
            </div>
            <div class="col-md-4 my-4">
              <label class="d-block" for="chk-ani13">
                <input class="checkbox_animated me-2" id="chk-ani13" type="checkbox" formControlName="proveedor" />
                <strong>PROVEEDOR</strong>
              </label>
              <label class="d-block" for="chk-ani14">
                <input class="checkbox_animated me-2" id="chk-ani14" type="checkbox" formControlName="aseguradora" />
                <strong>ASEGURADORA</strong>
              </label>
              <label class="d-block" for="chk-ani16">
                <input class="checkbox_animated me-2" id="chk-ani16" type="checkbox" formControlName="almacen" />
                <strong>ALMACÉN DE REPUESTO</strong>
              </label>
              <label class="d-block" for="chk-ani17">
                <input class="checkbox_animated me-2" id="chk-ani17" type="checkbox" formControlName="serviteca" />
                <strong>SERVITECAS</strong>
              </label>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button class="btn btn-primary" (click)="guardarEmpresa(modalEmpresaRef)">
          Guardar
        </button>
        <button class="btn btn-secondary" (click)="modal.dismiss()">
          Cancelar
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template #myModal2 let-modal>
    <div class="card border-4 rounded-3">
      <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
        <h5 class="mb-0"><strong>CREACIÓN DE CLASE DE VEHICULO</strong></h5>
      </div>
      <div class="modal-body">
        <form [formGroup]="formClase">
          <!-- Inputs antes de la tabla -->
          <div class="row g-3">
            <div class="col-md-3">
              <label class="form-label" for="tipos"><strong>Clase</strong></label>
              <input class="form-control" id="tipos" type="text" placeholder="Ingrese la clase"
                formControlName="tipos" />
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button class="btn btn-primary" (click)="guardarClase(modalClaseRef)">Guardar</button>
        <button class="btn btn-secondary" (click)="modal.dismiss()">
          Cancelar
        </button>
      </div>
    </div>
  </ng-template>